/**
 * shell/absentNote.ts —— `absent(declared)` 统一口径（声明在位、数据缺席）。
 *
 * 依据（逐字）：《UI 布局实体设计》§4 降级/缺席 —— **记残显示**（不假装可用）；
 *              判据 `ui_no_silent_absence`（**无静默缺席**：每个缺席须有说明）。
 */
export const ABSENT_DECLARED_NOTE =
  "absent(declared)：声明在位、数据缺席；入口禁用（不报错、不留空）";

/**
 * 人面文案（★20261005 报障③「页面大量文字描述是什么鬼？」订正）：
 * `ABSENT_DECLARED_NOTE` 是**工程口径**（供 `title`/判据用）；**不得**作为正文直接铺给人看。
 * 正文只出这一行（聚合），缺席入口名以 `、` 连接；每个入口仍各带 `title` 口径（无静默缺席不破）。
 */
export const ABSENT_HUMAN_LINE = "以下入口暂无数据（已禁用）：";

/** 人面「记残」提示（当前视图缺席时流内呈现；**不上工程口径**）。 */
export const ABSENT_HUMAN_NOTICE = "该视图暂无数据（声明在位）；入口已禁用";
